import Cookies from 'js-cookie';
// 注册渠道统计
export const UTM_TERM = new Set(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']);

export const SESSION_KEYS = {
  UTM_ITEM: 'utm_item',
  WEBSITE_INFO: 'website_info',
};
class sessionCache {
  setSession(name, value) {
    try {
      sessionStorage.setItem(name, value);
    } catch (error) {
      // to do: 报错处理
      console.error(error);
    }
  }

  removeSession(name) {
    try {
      sessionStorage.removeItem(name);
    } catch (error) {
      // to do: 报错处理
      console.error(error);
    }
  }

  getSession(name) {
    try {
      return sessionStorage.getItem(name);
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
const sCache = new sessionCache();

export default (SensorsSdk) => {
  if (!SensorsSdk || !window) return;
  // 神策
  let utmItem = sCache.getSession(SESSION_KEYS.UTM_ITEM) || '{}';
  let userInfo = localStorage.getItem('userInfo') || '{}';

  try {
    utmItem = JSON.parse(utmItem);
  } catch {
    utmItem = {};
  }
  try {
    userInfo = JSON.parse(userInfo);
  } catch {
    userInfo = {};
  }
  const sensors = new SensorsSdk({
    url: `${location.origin}/et/event/sa`, // 上传日志的接口地址
    showLog: location.host !== 'mastergo.com' ? false : true, // 是否在控制台显示日志信息
  });
  sensors.setPublic({
    device_hash: Cookies.get('_mg_cd_uid'),
    ...utmItem,
    ...userInfo,
    mguser_id: userInfo.id,
    user_name: userInfo.name,
  });
  return sensors;
};
